import { Component, inject } from '@angular/core';
import { CheckCircle2, LucideAngularModule, LucideIconData, XCircle } from 'lucide-angular';

import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <div class="toast-stack" aria-live="polite" aria-atomic="true">
      @for (toast of toastService.toasts(); track toast.id) {
        <div class="toast-item" [class.toast-success]="toast.variant === 'success'" [class.toast-error]="toast.variant === 'error'">
          <lucide-icon [img]="toast.variant === 'success' ? successIcon : errorIcon" size="18"></lucide-icon>
          <span>{{ toast.message }}</span>
          <button type="button" class="toast-close" (click)="toastService.dismiss(toast.id)" aria-label="Fechar aviso">×</button>
        </div>
      }
    </div>
  `,
  styles: `
    .toast-stack {
      position: fixed;
      top: 1rem;
      right: 1rem;
      left: 1rem;
      z-index: 1300;
      display: grid;
      gap: 0.6rem;
      justify-items: end;
      pointer-events: none;
    }

    .toast-item {
      pointer-events: auto;
      display: inline-flex;
      align-items: center;
      gap: 0.6rem;
      max-width: 420px;
      width: 100%;
      border-radius: var(--radius-md);
      border: 1px solid var(--color-border);
      background: var(--color-surface);
      box-shadow: var(--shadow-md);
      padding: 0.75rem 0.9rem;
      color: var(--color-text-primary);
      font-size: 0.88rem;
    }

    .toast-item span {
      flex: 1;
    }

    .toast-success {
      border-color: color-mix(in srgb, var(--color-success) 40%, var(--color-border));
      color: var(--color-success);
    }

    .toast-error {
      border-color: color-mix(in srgb, var(--color-danger) 40%, var(--color-border));
      color: var(--color-danger);
    }

    .toast-close {
      border: 0;
      background: transparent;
      color: inherit;
      font-size: 1.1rem;
      line-height: 1;
      cursor: pointer;
      padding: 0 0.15rem;
    }

    @media (min-width: 768px) {
      .toast-stack {
        left: auto;
        width: 420px;
      }
    }
  `
})
export class ToastComponent {
  protected readonly toastService = inject(ToastService);

  protected readonly successIcon: LucideIconData = CheckCircle2;
  protected readonly errorIcon: LucideIconData = XCircle;
}
